const { each, map } = require('lodash');

class TrackMyOrderGuestFormController {
    constructor($timeout, trackMyOrderService, analyticsService) {
        this.$timeout = $timeout;
        this.trackMyOrderService = trackMyOrderService;
        this.analyticsService = analyticsService;
    }

    $onInit() {
        this.tmoInfo = null;

        // Attempt to load, a small delay is needed to wait for form load
        this.$timeout(() => {
            if (this.orderNumber) {
                this.submit();
            }
        });
    }

    submit() {
        // Reset
        this.isLoading = true;
        this.tmoInfo = null;
        this.tmoForm.OrderNumber.$setValidity('serverError', 'true');

        if (!this.tmoForm.$valid) {
            this.isLoading = false;
            return;
        }

        this.trackMyOrderService.getOrderInfo(this.orderNumber).then((response) => {
            this.tmoInfo = response;
        }).catch((response) => {
            this.isLoading = false;
            this.serverErrors = {};
            if (response.data && response.data.ResponseStatus) {
                each(response.data.ResponseStatus.Errors, (n) => {
                    if (this.tmoForm[n.FieldName]) {
                        this.tmoForm[n.FieldName].$setValidity('serverError', false);
                        this.tmoForm.$invalid = true;
                    }
                    this.serverErrors[n.FieldName] = n.Message;
                });
                this.analyticsService.pushErrors(map(response.data.ResponseStatus.Errors, 'Message'));
            }
        }).finally(() => {
            this.isLoading = false;
        });
    }
}

TrackMyOrderGuestFormController.$inject = ['$timeout', 'TrackMyOrderService', 'AnalyticsService'];

const trackMyOrderGuestFormComponentDefinition = {
    controller: TrackMyOrderGuestFormController,
    template: require('./trackmyorder-guest-form.component.html').trim(),
    bindings: {
        orderNumber: '<',
    },
};

module.exports = {
    TrackMyOrderGuestFormController,
    trackMyOrderGuestFormComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/trackmyorder/trackmyorder-guest-form.component.js